import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function Specialized() {

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true,
        },
      },
    ],
  };

  // Handle hash-based scrolling
  const ScrollToHashElement = () => {
    const { hash } = useLocation();

    useEffect(() => {
      if (hash) {
        const element = document.querySelector(hash);

        if (element) {
          setTimeout(() => {
            element.scrollIntoView({
              behavior: 'smooth',
            });
          }, 100);
        }
      }
    }, [hash]);
  };

  ScrollToHashElement();

  return (
    <div className="container">
      <div className="specialized-section">

        <h2>
          Specialized & <span>Preventive Care</span>
        </h2>

        <p className="limit-width">
          Transform your health with our General & specialized services.
          Our expert team ensures comprehensive care for a confident lifestyle.
        </p>

        <Slider {...settings}>

          {/* 1. Clinic Consultation */}
          <div className="articles-item">
            <div className="shadow-box">
              <Link to="/our-services#clinicConsultation">

                <img
                  className="img-fluid specialized-service-img"
                  src={`${process.env.PUBLIC_URL}/img/famphy-services-02.jpg`}
                  alt="Clinic Consultation"
                />

                <h5>Clinic Consultation</h5>

              </Link>
            </div>
          </div>


          {/* 2. Home Visits */}
          <div className="articles-item">
            <div className="shadow-box">
              <Link to="/our-services#homeVisit">

                <img
                  className="img-fluid specialized-service-img"
                  src={`${process.env.PUBLIC_URL}/img/famphy-services-01.jpg`}
                  alt="Home Visits"
                />

                <h5>Home Visits</h5>

              </Link>
            </div>
          </div>


          {/* 3. Lab Investigation */}
          <div className="articles-item">
            <div className="shadow-box">
              <Link to="/our-services#labTests">

                <img
                  className="img-fluid specialized-service-img"
                  src={`${process.env.PUBLIC_URL}/img/famphy-services-04.jpg`}
                  alt="Lab Investigation"
                />

                <h5>Lab Investigation</h5>

              </Link>
            </div>
          </div>


          {/* 4. Ultrasound */}
          <div className="articles-item">
            <div className="shadow-box">
              <Link to="/our-services#ultrasound">

                <img
                  className="img-fluid specialized-service-img"
                  src={`${process.env.PUBLIC_URL}/img/famphy-services-06.png`}
                  alt="Ultrasound"
                />

                <h5>Ultrasound</h5>

              </Link>
            </div>
          </div>


          {/* 5. Vaccinations */}
          <div className="articles-item">
            <div className="shadow-box">
              <Link to="/our-services#vaccinations">

                <img
                  className="img-fluid specialized-service-img"
                  src={`${process.env.PUBLIC_URL}/img/famphy-services-05.jpg`}
                  alt="Vaccinations"
                />

                <h5>Vaccinations</h5>

              </Link>
            </div>
          </div>

        </Slider>

      </div>
    </div>
  );
}